import React from 'react';
import Med_Logo from '../img/MEDEUON.png';
import './css/company_icon.css';
import { TbBackground } from 'react-icons/tb';

const Logo = () => {

    // name je jove ch te nathee avtu
  const COM_LOGO = sessionStorage.getItem('com_logo');

  return (
    <>
    <div className="header-container">
      {/* Left side */}
      <div className="left-icon">
        <img src={Med_Logo} alt="Company Logo Left" />
      </div>

      {/* Right side */}
      <div className="right-icon">
        {COM_LOGO && (
          <img
            src={require(`../img/${COM_LOGO}`)}
            alt="Company Logo Right"
          />
        )}
      </div>
      </div>

    {/* marquee small new hader */}
    <div>
        
        <div className="container"> 
        <div className="headertext"></div> 

        <div>
        <marquee style={{width:'100%',color:'black', backgroundColor:'red'}} 
        onmouseover="this.stop();" onmouseout="this.start();" 
        direction="left" behavior="scroll" scrollamount="7">
        Medeuon Company is a IT support          |&nbsp;&nbsp;&nbsp; 
        Medeuon Company is a IT support          |&nbsp;&nbsp;&nbsp; 
        Medeuon Company is a IT support          
        </marquee>
        </div>

    </div> 
    </div>

  </>
  );
};

export default Logo;
